// Third Party
import React from 'react';

// Components
import GenericHolding from '../holdings-editor/GenericHolding';
import BenchmarkHolding from '@/types/benchmark-holding';
import ComparisonHolding from '@/types/comparison-holding';

// Types
import ThemeMode from '@/types/theme-mode';

type Props = {
  holding: BenchmarkHolding | ComparisonHolding;
  onWeightChange: (holdingId: string, weight: number) => void;
  onRemoveHolding: (holdingId: string) => void;
  holdingCount: number;
  readOnly?: boolean;
  showCurrencies: boolean;
  disabled?: boolean;
  showDelete?: boolean;
  theme?: ThemeMode;
};

class EditBenchmarkHolding extends React.Component<Props> {
  static defaultProps = {
    onWeightChange: () => {},
    onRemoveHolding: () => {},
  };

  onWeightChange = (weight: number) => {
    const { holding } = this.props;

    const newWeight = Math.max(0, Math.min(100, weight));
    this.props.onWeightChange(holding.id, newWeight);
  };

  onRemoveHolding = () => {
    const { holding } = this.props;

    this.props.onRemoveHolding(holding.id);
  };

  render() {
    const {
      holding: { name, currency, symbol, weight },
      readOnly,
      showCurrencies,
      disabled,
      showDelete,
      theme,
    } = this.props;

    return (
      <GenericHolding
        name={name}
        currency={currency}
        symbol={symbol}
        weight={weight}
        onWeightChange={this.onWeightChange}
        onRemoveHolding={this.onRemoveHolding}
        showDelete={showDelete}
        readOnly={readOnly}
        showCurrencies={showCurrencies}
        weightDisabled={disabled}
        theme={theme}
      />
    );
  }
}

export default EditBenchmarkHolding;
